<template>
  <div class="znfp-wrap">
    <div class="auto">
      <div class="header">
        <span class="btn-buy" @click="goUrl(73)"></span>
        <span class="time">购买热线：021-20219999</span>
      </div>
      <div class="info-box">
        <p>2021年3月1日开始，只花<em>￥2680 </em>购买《大智慧专业版》即可获得[复盘大师]的“旗舰装备”——<strong>[智能复盘统计]</strong>，实惠！</p>
      </div>
      <div class="title">功能介绍</div>
      <div class="mod">
        <div class="mod-con">
          <dl>
            <dt>复盘：是获得较快的进步的最佳途径，是提升自我的有效方法之一。</dt>
            <dd>
              <p>【智能复盘统计】以云端大数据为基础，深度挖掘、分析海量交易信息，通过智能算法，监控盘中任意时段的热门板块、个股的异动情况，智能甄别热门个股的跟涨板块、热门板块的领涨个股；并提供阶段内的ACE资金流向、个股的指数贡献点、阶段振幅等辅助复盘作业的基础数据。</p>
              <img src="../../assets/images/activity/znfp2021/img1.jpg" alt="">  
            </dd>
            <dd>
              <p>【智能复盘统计】大幅减轻了投资者的复盘工作量，节约了投资者盘中宝贵的时间，不仅让盘中快速进行复盘分析变为现实，而且功能极为简便，只需轻轻划一下鼠标，一键即可完成。把投资者在交易时段来不及分析总结的市场全貌、隐藏在盘面里的各种细节，展示的淋漓尽致。实为复盘大师们的“旗舰装备”。</p>
              <img src="../../assets/images/activity/znfp2021/img2.jpg" alt="">  
            </dd>
          </dl>
        </div>
      </div>
    </div>
    <div class="buy-box">
      <div class="auto">
        <div class="tel">
          <p>购买热线</p>
          <p>021-20219999</p>
        </div>
        <span class="btn-buy" @click="goUrl(73)"></span>
      </div>
    </div>
    <div class="note">
      免责提醒：智能复盘统计监控客观数据，结果无人为干预。工具仅供参考，理性决策，责任自负！入市需谨慎！
    </div>
  </div>
</template>

<script>
export default {
 data () {
    return {
      token: ''
    }
  },
  created() {
    var token = this.$route.query.token;
    if (token) {
      this.token = token;
    }
  },
  methods: {
    goUrl (key) {
      let routerDate;
      if (this.token) {
        routerDate = this.$router.resolve({name: 'ClientProduct', query: {token: this.token, pid: key}})
      } else {
        routerDate = this.$router.resolve({name: 'OrderConfirm', params:{productId: key,month:12}})
      }
      let {href} = routerDate
      window.open(href, "_blank")
    }
  },
}
</script>

<style lang="scss" scoped>
.znfp-wrap{
  padding-top: 474px;
  background: url(../../assets/images/activity/znfp2021/bg1.jpg) no-repeat center 0,
              url(../../assets/images/activity/znfp2021/bg2.jpg) no-repeat center 640px #f37e5e;
  .auto{
    @include auto(1200px);
  }
  .header{
    .btn-buy{
      cursor: pointer;
      display: block;
      @include wh(296px,95px);
      margin-left: 538px;
    }
    .time{
      display: block;
      @include wh(296px,36px);
      margin: 23px 0 20px 538px;
      line-height: 36px;
      text-align: center;
      background: rgba($color: #000000, $alpha: 0.1);
      border-radius: 30px;
      @include fc(22px, #99ffff);
      font-weight: bold;
    }
  }
  .info-box{
    padding: 40px 0 0 40px;
    box-sizing: border-box;
    width: 1100px;
    margin: 0 auto 115px;
    position: relative;
    @include fc(30px, #9e4b29);
    line-height: 48px;
    height: 200px;
    margin-bottom: 55px;
    p{
      em{
        color: #e61d26;
      }
      strong{
        background: #ee5246;
        padding: 5px 12px 7px;
        border-radius: 10px;
        color: #fff;
        margin-left: 5px;
      }
    }
  }
  .title{
    @include fc(56px, #fff);
    font-style: italic;
    text-align: center;
    text-shadow: 0 3px 3px rgba($color: #000000, $alpha: 0.3);
  }
  .mod{
    border: 7px solid #f67256;
    border-radius: 30px;
    box-shadow: 0 5px 9px #e54d30;
    .mod-con{
      border: 7px solid #faab84;
      border-radius: 22px;
      background: #8e4325;
    }
    dl{
      dt{
        line-height: 98px;
        @include fc(36px, #ffb487);
        padding-left: 35px;
        background: #a24c2a;
        border-radius: 22px 22px 0 0;
      }
      dd{
        padding: 25px 0;
        margin: 0 35px;
        &:nth-of-type(1) {
          border-bottom: 4px solid #9c5335;
        }
        p{
          @include fc(30px, #fedfbe);
          line-height: 40px;
          text-align: justify;
          margin-bottom: 20px;
        }
        img{
          display: block;
          border-radius: 9px 9px 0 0 ;
          width: 100%;
        }
      }
    }
  }
  .buy-box{
    width: 100%;
    background: linear-gradient(to bottom, #ca6441,#b35535);
    overflow: hidden;
    padding-bottom: 33px;
    margin-top: 38px;
    .tel{
      float: left;
      margin: 60px 42px 0 50px;
      p{
        @include fc(30px, #ffcb85);
        &:first-child{
          margin-bottom: 15px;
        }
      }
    }
    .btn-buy{
      @include wh(650px, 134px);
      float: left;
      display: block;
      cursor: pointer;
      margin-top: 33px;
      background: url(../../assets/images/activity/znfp2021/btn-buy.png) no-repeat;
    }
  }
  .note{
    text-align: center;
    @include fc(18px, #e67a5c);
    background: #994028;
    padding: 13px 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/activity/Znfp2021.vue